// import axios from "../api/Axios";
// import Swal from "sweetalert2";

// export const axiosPrivate = axios.create({});

// axiosPrivate.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const prevRequest = error?.config;
//     if (error.response.status === 401 && !prevRequest?.sent) {
//       try {
//         prevRequest.sent = true;
//         const refToken = await localStorage.getItem("userRefToken");
//         // const redToken = await localStorage.getItem("surveyorRefToken")
//         // console.log(redToken,"999999");
        
//         console.log("refToken", refToken);
//         const response = await axios.post(
//           "/auth/refresh-token",
//           { refToken },
//           { withCredentials: true }
//         );
//         if (response.data.success) {
//           localStorage.setItem("userRefToken", response.data.refreshToken);
//         }

//         // if()
       
//       } catch (error) {
//         console.log(error, "qwerty");
//         Swal.fire({
//           title: error.response.data.message.name,
//           text: error.message + " (Please login again...)",
//         }).then(() => {
//           localStorage.clear();

//           window.location.href = "/";
//         });

//         return Promise.reject(error);
//       }
//       return axios(error.config);
//     }
//     return Promise.reject(error);
//   }
// );

import axios from "../api/Axios";
import Swal from "sweetalert2";

export const axiosPrivate = axios.create({});

axiosPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log(error,"errorrrrr");
    
    const prevRequest = error?.config;
    if (error?.response?.status === 403 && !prevRequest?.sent) {
      try {
        prevRequest.sent = true;
        
        // Get all types of refresh tokens
        const refToken = await localStorage.getItem("refToken");
        
        // Determine which token to use and set the corresponding endpoint
        let refreshEndpoint;
          refreshEndpoint = "/auth/refresh-token";
       

        console.log("Using refresh endpoint:", refreshEndpoint);

        if (!refToken || !refreshEndpoint) {
          throw new Error("No refresh token found or unable to determine user type");
        }

        const response = await axios.post(
          refreshEndpoint,
          { refToken },
          { withCredentials: true }
        );

        if (response.data.success) {
          // Store the new refresh token based on the user type
          if (refToken) localStorage.setItem("refToken", response.data.refreshToken);
          
        }

      } catch (error) {
        console.log(error, "Error refreshing token");
        Swal.fire({
          title: error.response?.data?.message?.name || "Authentication Error",
          text: (error.message || "An error occurred") + " (Please login again...)",
        }).then(() => {
          localStorage.clear();
          window.location.href = "/";
        });

        return Promise.reject(error);
      }
      return axios(error.config);
    }
    return Promise.reject(error);
  }
);
